import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    usersSelector,
    isFetchingSelector,
    errorSelector,
    totalUsersSelector,
    searchTextSelector
} from '../selectors/userSelectors';
import { getUsersRequest, cleanUsers } from '../actions/userActions';
import UsersList from '../components/UsersList/UsersList';

const mapStateToProps = createStructuredSelector({
    total: totalUsersSelector,
    users: usersSelector,
    isFetching: isFetchingSelector,
    error: errorSelector,
    searchText: searchTextSelector
});

const mapDispatchToProps = {
    getUsersRequest,
    cleanUsers
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersList);
